import { iRegion } from '@/interface/region';
import request from '@/utils/request';

/**
 *【大区管理】大区详情
 * @param params
 */
export const getRegion = (sort_id: number): Promise<any> =>
  request({
    url: '/api/v1/omc/regions',
    params: { sort_id },
  });
/**
 * 【大区管理】大区修改
 * @param params
 */
export const updateRegion = (data: iRegion): Promise<any> =>
  request({
    url: '/api/v1/omc/region',
    data,
    method: 'put',
  });

export const getRegionDetail = (id: number): Promise<any> =>
  request({
    url: '/api/v1/omc/region?id=' + id,
    method: 'get',
  });
